"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var SwitchLabel_1 = __importDefault(require("./common/SwitchLabel"));
var FormComponentUtils_1 = require("./common/FormComponentUtils");
var HookUtils_1 = require("../../common/HookUtils");
var KeyboardEventKeys_1 = __importDefault(require("../../common/enums/KeyboardEventKeys"));
var FieldValidationState_1 = require("./common/FieldValidationState");
var ValidationMessage_1 = __importDefault(require("./common/ValidationMessage"));
var Checkbox = function (props) {
    var additionalInfo = props.additionalInfo, checked = props.checked, indeterminate = props.indeterminate, disabled = props.disabled, formControlProps = props.formControlProps, invalid = props.invalid, label = props.label, large = props.large, name = props.name, onChange = props.onChange, onFilterSelected = props.onFilterSelected, readonly = props.readonly, validationMessage = props.validationMessage, validationState = props.validationState, value = props.value;
    var _a = HookUtils_1.useStateWithSingleProp(checked), tempChecked = _a[0], setTempChecked = _a[1];
    var tempValue = react_1.default.useState(value)[0];
    var inputRef = react_1.useRef(null);
    var handleCheckedSelectionCallback = function (checked) {
        onFilterSelected && onFilterSelected(checked);
    };
    react_1.useEffect(function () {
        inputRef.current.indeterminate = indeterminate;
    }, [indeterminate]);
    react_1.useEffect(function () {
        handleCheckedSelectionCallback(checked);
    }, [checked]); // eslint-disable-line react-hooks/exhaustive-deps
    var updateWrapper = function (evt) {
        handleCheckedSelectionCallback(evt.target.checked);
        onChange && onChange(evt);
    };
    var keyHandler = function (evt) {
        if (readonly && evt.key !== KeyboardEventKeys_1.default.TAB) {
            evt.preventDefault();
        }
    };
    var restrictedProps = [
        'checked', 'className', 'disabled', 'name', 'onChange', 'onKeyDown', 'type', 'value'
    ];
    var attributes = FormComponentUtils_1.getFormControlAttributes(formControlProps, restrictedProps);
    return (react_1.default.createElement("label", { className: getClassNames(props) },
        react_1.default.createElement("input", __assign({ ref: inputRef }, attributes, { checked: tempChecked, className: "fds-switch-input", disabled: disabled, name: name, onChange: function (evt) { return FormComponentUtils_1.handleCheckedChange(evt, setTempChecked, updateWrapper); }, onKeyDown: keyHandler, type: "checkbox", value: tempValue })),
        react_1.default.createElement("span", { className: classnames_1.default('fds-switch-control', { 'is-readonly': readonly }), "aria-hidden": "true" }),
        react_1.default.createElement(SwitchLabel_1.default, { additionalInfo: additionalInfo, label: label, large: large },
            react_1.default.createElement(ValidationMessage_1.default, { validationMessage: validationMessage, validationState: invalid ? FieldValidationState_1.FieldValidationState.INVALID : validationState }))));
};
var getClassNames = function (props) {
    var classes = props.classes, disabled = props.disabled, fullWidth = props.fullWidth, inline = props.inline, invalid = props.invalid, label = props.label, readonly = props.readonly, reverse = props.reverse, validationState = props.validationState;
    return classnames_1.default('fds-switch', 'fds-switch-checkbox', {
        'is-disabled': disabled,
        'fds-inline-switch': inline,
        'fds-switch-reverse': reverse,
        'fds-form-control-full-width': fullWidth,
        'is-readonly': readonly,
        'fds-switch-checkbox-no-label': label === '',
        invalid: invalid || validationState === FieldValidationState_1.FieldValidationState.INVALID,
        valid: validationState === FieldValidationState_1.FieldValidationState.VALID
    }, classes);
};
Checkbox.defaultProps = {
    checked: false // Explicity set to to make sure checked is always a boolean type as props.checked is bound to state
};
exports.default = Checkbox;
